import { render } from "./LoadingOverlay.vue?vue&type=template&id=2a7e2e77&scoped=true&ts=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=2a7e2e77&lang=scss"
import "./LoadingOverlay.vue?vue&type=style&index=1&id=2a7e2e77&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7e2e77"]])

export default __exports__